/*
hdx-content-banner-directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/widgets/content-banner/js/directive/hdx-content-banner-directive',['jquery', 'angular'], function ($, angular) {

    var module = angular.module('hdxBannerModule', []);
    module.constant('IS_TOUCH_DEVICE', (function () {
        // Best way to detect non-angular flags
        return 'ontouchstart' in window;
    })());
    module.controller('hdxContentBannerCtrl', ['$scope', '$filter', function ($scope, $filter) {
        $scope.showDetails = false;
        var validColDefinitions = ['xs', 'sm', 'md', 'lg'];

        $scope.toggleDetails = function () {
            $scope.showDetails = !$scope.showDetails;
        };

        function applyFilters(input, filterList) {
            return filterList.reduce(function (subresult, filter) {
                var filterArgs = filter.split(':'),
                    filterName = filterArgs.shift();

                return $filter(filterName).apply(null, [subresult].concat(filterArgs));
            }, input);
        }

        $scope.formatData = function (columnConfig) {
            var result = $scope.bannerData[columnConfig.dataKey] || 'N/A';
            if (columnConfig.filters) {
                result = applyFilters(result, columnConfig.filters);
            }
            return result;
        };

        function getColValue(val, inverse) {
            return inverse ? (12 - val) : val;
        }

        function calculateColumnClasses(obj, defaultClasses, inverse) {
            var klass = defaultClasses;
            if (obj && obj.col) {
                if (typeof obj.col === 'object') {
                    klass = validColDefinitions.reduce(function (partial, key) {
                        if (obj.col[key]) {
                            partial += ' col-' + key + '-' + getColValue(obj.col[key], inverse);
                        }
                        return partial.trim();
                    }, '');
                } else {
                    klass = 'col-xs-' + getColValue(obj.col, inverse) + ' col-sm-' + getColValue(obj.col, inverse);
                }
            }
            return klass;
        }

        $scope.getTitleClass = function () {
            var klass = 'col-xs-12 col-sm-12';
            if ($scope.bannerConfig.labels) {
                klass = calculateColumnClasses($scope.bannerConfig.labels, 'col-xs-9 col-sm-9', true);
            }
            return klass;
        };

        $scope.getLabelClass = function () {
            return calculateColumnClasses($scope.bannerConfig.labels, 'col-xs-3 col-sm-3');
        };

        $scope.getColumnClasses = function (columnConfig) {
            var klasses = calculateColumnClasses(columnConfig, 'content-banner-details col-xs-3 col-sm-3');
            if (columnConfig.classes) {
                if (Array.isArray(columnConfig.classes)) {
                    klasses += ' ' + columnConfig.classes
                        .reduce(function (result, klass) {
                            result += ' ' + klass;
                            return result;
                        }, '');
                } else if (typeof columnConfig.classes === 'string') {
                    klasses += ' ' + columnConfig.classes;
                }
            }

            if (columnConfig.highlighted) {
                klasses += ' content-banner-details__highlighted';
            }

            return klasses;
        };

    }]);
    module.directive('hdxContentBanner', ['$document', '$timeout', 'IS_TOUCH_DEVICE', function ($document, $timeout, IS_TOUCH_DEVICE) {
        return {
            restrict: 'EA',
            replace: 'true',
            scope: {
                templateUrl: '=',
                bannerData: '=',
                bannerConfig: '='
            },
            transclude: true,
            template: '<div>' + '<div ng-if="templateUrl" ng-include=templateUrl/>' +
                '<section class="content-banner" ng-if="!templateUrl">' +
                '<div class="container-fluid">' +
                '<div class="row">' +
                '<div class="content-banner-title content-banner-value" ng-class="getTitleClass()">' +
                '{{bannerData[bannerConfig.title.dataKey] || \'N/A\'}}' +
                '</div>' +
                '<div ng-if="bannerConfig.labels" class="content-banner-label" ng-class="getLabelClass()">' +
                '<div ng-repeat="labelData in bannerConfig.labels.configs" class="{{labelData.class}}" translate-key="{{bannerData[labelData.dataKey]}}" ng-bind="bannerData[labelData.dataKey] | translate">' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div class="row content-banner-details" ng-repeat="datarow in bannerConfig.rows" ng-class="{\'content-banner-details-additional\': $index > 0, \'content-banner-details-additional__hidden\': $index > 0 && !showDetails}">' +
                '<div ng-repeat="datacol in datarow" ng-class="getColumnClasses(datacol)">' +
                '<div class="content-banner-value">{{formatData(datacol)}}</div>' +
                '<div class="content-banner-key" translate={{datacol.label}}></div>' +
                '</div>' +
                '</div>' +
                '<div class="content-banner-toggle-button" ng-if="bannerConfig.rows.length > 1" ng-click="toggleDetails()">' +
                '<i ng-class="{\'icon-ico_chevron_down_lg\': !showDetails, \'icon-ico_chevron_up_sm\': showDetails}"></i>' +
                '</div>' +
                '</div>' +
                '</section>' + '</div>',
            controller: 'hdxContentBannerCtrl',
            link: function (scope, element) {
                var $elem = element;

                function clearTooltips() {
                    $elem.find('.single-tooltip-source').each(function (index, elem) {
                        removeTooltip(angular.element(elem));
                    });
                }

                function removeTooltip(elem) {
                    elem.removeClass('single-tooltip-source');
                    elem.tooltip('hide');
                    elem.removeAttr('data-original-title');
                }

                function handleTooltips(elem) {
                    var $this = angular.element(elem);
                    if (elem.offsetWidth < elem.scrollWidth) {
                        $this.tooltip('destroy');
                        $this.attr('data-original-title', $this[0].innerText);
                        $this.tooltip({ placement: 'bottom', container: '.content-banner' }).tooltip('show');
                        $this.addClass('single-tooltip-source');
                    } else {
                        removeTooltip($this);
                    }
                }

                var addSizeListerners = (function (eventName) {
                    return function () {
                        clearTooltips();
                        var $values = $elem.find('.content-banner-value');
                        // Remove old event listener
                        $values.unbind(eventName);
                        $values.bind(eventName, function () {
                            handleTooltips(this);
                        });
                    };
                })(IS_TOUCH_DEVICE ? 'click' : 'mouseenter');

                scope.$watch('bannerData', handleDataChange);
                scope.$watch('bannerConfig', handleDataChange);
                function handleDataChange() {
                    scope.$evalAsync(function () {
                        //Template has been rendered, now add listeners.
                        addSizeListerners();
                    });
                }
                // Wait for templates to render
                $timeout(function () {
                    addSizeListerners();
                }, 100);

                if (IS_TOUCH_DEVICE) {
                    $document.on('touchstart', clearTooltips);
                }
            }
        };
    }]);
});

